import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { GRADIENTS } from '@components/web/src/styles';

export const ProductFeedbackCommentCardContainer = styled(Flexbox)`
  width: 100%;
  border-radius: 8px;
  background: ${GRADIENTS.characterGradient};
`;

export const CommentWrapper = styled(Flexbox)`
  textarea::-webkit-scrollbar {
    width: 0;
  }
`;
